<ng-template [sbmodal]="'inventorySelectionModal'">
  <sb-custom-modal [templateId]="'inventorySelectionModal'">
    <div slot="body">
      <sb-page-inventory-wrapper [isInModalContext]="true"></sb-page-inventory-wrapper>
    </div>
  </sb-custom-modal>
</ng-template>

<ng-template [sbmodal]="'filterEditModal'">
  <sb-custom-modal [templateId]="'filterEditModal'">
    <div slot="body">
      <filter-edit></filter-edit>
    </div>
  </sb-custom-modal>
</ng-template>

<ng-template [sbmodal]="'finishmodal'">
  <sb-custom-modal [templateId]="'finishmodal'">
    <div slot="body">
      <div class="d-flex justify-content-center">
        <sb-icon
          style="font-size: 5rem" icon="successAnimation"
          [animationOptions]="{autoplay: true, loop: false}" class="green"></sb-icon>
      </div>
      <div class="mt-4">
        {{ !requirementId ? ('lang.requirementEdit.createdSuccessfully' | translate) : ('lang.requirementEdit.editedSuccessfully' | translate) }}
      </div>
      <div *ngIf="showBookingsNotice()">
        {{ 'lang.globals.bookingsVerificationPending' | translate }}
      </div>
    </div>
    <div slot="footer">
      <sb-button (click)="modal.close('finishmodal')"
                 classes="btn-secondary btn-sm text-uppercase mr-0">{{ 'lang.globals.ok' | translate }}
      </sb-button>
    </div>
  </sb-custom-modal>
</ng-template>

<sb-comp-ccr-hero [ccr]="campaign" [isCollapsed]="true"></sb-comp-ccr-hero>
<sb-comp-ccr-hero [ccr]="commercial" [isCollapsed]="true"></sb-comp-ccr-hero>

<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading" [loadingDelay]=1>
      <div card-fit>
        <ng-template #tab1Headline>
          <ng-container *ngIf="requirement?.name">
            <table style="font-size: .9rem;">
              <tr class="font-weight-bold my-2">
                <td>
                  <span [innerHTML]="requirement?.name | truncate : 20"></span>
                </td>
              </tr>
            </table>
          </ng-container>
        </ng-template>
        <sb-wizard #wizard classes="wizard__minHeightSetting">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.settings' | translate }}" icon="basicSettings"
                         [headlineTemplate]="tab1Headline">
            <form [formGroup]="form" (ngSubmit)="nextStep(wizard, tab2)" class="wizard__forms px-5 pb-5">
              <div class="row">
                <div class="col-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{ 'lang.requirementEdit.title' | translate }}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Title">
                    <div *ngIf="Title.dirty && Title.errors?.required"
                         class="alert alert-danger">{{ 'lang.requirementEdit.titleWarning' | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-xl-6">
                  <div class="form-group validateMe d-block">
                    <label class="form-label" for="Identifier">{{ 'lang.globals.identifier' | translate }}</label>
                    <div class="d-flex">
                      <input class="form-control mr-1" formControlName="Identifier" id="Identifier" type="text">
                    </div>
                    <span class="form-text text-muted">{{ 'lang.globals.identifierDescription' | translate }}</span>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="form-group validateMe d-block">
                    <label class="form-label" for="Description">{{ 'lang.globals.description' | translate }}</label>
                    <div class="d-flex">
                      <input class="form-control mr-1" formControlName="Description" id="Description" type="text">
                    </div>
                    <span class="form-text text-muted">{{ 'lang.globals.descriptionDescription' | translate }}</span>
                  </div>
                </div>
              </div>

            </form>
            <div class="row px-5">
              <div class="col-md-6">
                <div class="form-group validateMe">
                  <label class="form-label" for="Position">{{ 'lang.globals.position' | translate }}</label>
                  <select id="Position" class="form-select" [ngModel]="pickedPosition"
                          (ngModelChange)="updatePosition($event)">
                    <option *ngFor="let req of requirements"
                            [ngValue]="req"
                            [ngClass]="{'font-weight-bold': req?.id?.toString() === requirementId?.toString()}">
                      {{ req?.id?.toString() === requirementId?.toString() ? ('lang.globals.holdPosition' | translate) : req.name }}
                    </option>
                    <option [ngValue]="null"
                            class="font-weight-bold">{{ 'lang.globals.positionAtEnd'|translate }}
                    </option>
                  </select>
                  <span class="form-text text-muted">{{ 'lang.globals.positionDescription' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="wizard__footerActions p-5">
              <button
                (click)="util.returnToNavigation(util.RoutingID.requirements, [{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercialId}])"
                type="button" class="btn btn-default btn-wizard">{{ 'lang.globals.cancel' | translate }}
              </button>
              <button type="button" (click)="nextStep(wizard, tab2)" class="btn btn-primary btn-wizard"
                      [disabled]="!form.valid">{{ 'lang.globals.next' | translate }}
              </button>
            </div>
          </sb-wizard-tab>
          <sb-wizard-tab #tab2 titleText="{{ 'lang.wizard.tabs.selection' | translate }}" icon="selection"
                         [disabled]="!form.valid">
            <div class="wizard__forms px-5 pb-5">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <h3>{{ 'lang.requirementEdit.headline' | translate }} </h3>
                <h6>
                  <sb-icon icon="location"></sb-icon>
                  {{ previewRequirementData?.playerAggregation?.locations }} {{ 'lang.globals.locations' | translate }} /
                  <sb-icon icon="playerOnline"></sb-icon>
                  {{ previewRequirementData?.playerAggregation?.screens }} {{ 'lang.globals.player' | translate }}
                </h6>
              </div>
              <div *ngPermissions="[permissionService.Permission.cull_show]" class="wizard__forms__filterWrapper">

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizard__forms__filterWrapper__filterStep__singleFilter__headline">
                    <h6>{{ 'lang.globals.campaignFilter' | translate }}</h6>
                  </div>
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizard__forms__filterWrapper__filterStep__singleFilter__headline">
                    <h6>{{ 'lang.globals.commercialFilter' | translate }}</h6>
                  </div>
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizard__forms__filterWrapper__filterStep__singleFilter__headline">
                    <h6>{{ 'lang.requirementEdit.requirementFilter' | translate }}</h6>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : campaign?.timeCull}" icon="calendar"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 [innerHTML]="this.campaign?.timeCull?.name | truncate : 7" style="margin: 0 0 0 1rem;"
                          *ngIf="this.campaign?.timeCull?.name"></h3>
                    </div>
                  </div>
                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : commercial?.timeCull}" icon="calendar"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 [innerHTML]="this.commercial?.timeCull?.name | truncate : 7" style="margin: 0 0 0 1rem;"
                          *ngIf="this.commercial?.timeCull?.name"></h3>
                    </div>
                  </div>
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('TimeCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : requirement?.timeCull}" icon="calendar"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="this.requirement?.timeCull?.name"
                          [innerHTML]="this.requirement?.timeCull?.name | truncate : 9"></h3>
                      <label class="form-label">{{ 'lang.globals.timeFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                 (click)="changeWizardState('TimeCullSelect')"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate }}"
                                 placement="top" container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='TimeCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!this.requirement?.timeCull && permissionService.hasPermissions([permissionService.Permission.cull_time_create])"
                        (click)="changeWizardState('TimeCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='TimeCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="this.requirement?.timeCull && !this.requirement?.timeCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_time_edit])"
                        (click)="changeWizardState('TimeCullEdit')"
                        ngbTooltip="{{'lang.globals.editFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='TimeCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="this.requirement?.timeCull" (click)="sliceCull($event, 'TimeCull')"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate }}" placement="top"
                                 container="body"
                                 classes="btn-danger m-0">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : campaign?.playerCull}" icon="playerOnline"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 [innerHTML]="this.campaign?.playerCull?.name | truncate : 7" style="margin: 0 0 0 1rem;"
                          *ngIf="this.campaign?.playerCull?.name"></h3>
                    </div>
                  </div>
                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : commercial?.playerCull}" icon="playerOnline"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 [innerHTML]="this.commercial?.playerCull?.name | truncate : 7" style="margin: 0 0 0 1rem;"
                          *ngIf="this.commercial?.playerCull?.name"></h3>
                    </div>
                  </div>
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('PlayerCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : requirement?.playerCull}" icon="playerOnline"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="this.requirement?.playerCull?.name"
                          [innerHTML]="this.requirement?.playerCull?.name | truncate : 9"></h3>
                      <label class="form-label">{{ 'lang.globals.playerFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                 (click)="changeWizardState('PlayerCullSelect')"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate }}"
                                 placement="top" container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!this.requirement?.playerCull && permissionService.hasPermissions([permissionService.Permission.cull_player_create])"
                        (click)="changeWizardState('PlayerCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <span class="btn-separator" *ngIf="!this.requirement?.playerCull">|</span>
                      <sb-button
                        *ngIf="!this.requirement?.playerCull && permissionService.hasPermissions([permissionService.Permission.cull_player_create])"
                        (click)="openInventoryView()" ngbTooltip="{{'lang.globals.selectScreens' | translate}}"
                        placement="top" container="body"
                        classes="btn-hover-primary m-0 green">
                        <sb-icon icon="checkList"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="this.requirement?.playerCull && !this.requirement?.playerCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_player_edit])"
                        (click)="changeWizardState('PlayerCullEdit')"
                        ngbTooltip="{{'lang.globals.editFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="this.requirement?.playerCull" (click)="sliceCull($event, 'PlayerCull')"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate }}" placement="top"
                                 container="body"
                                 classes="btn-danger m-0">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : campaign?.geoCull}" icon="globe"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 [innerHTML]="this.campaign?.geoCull?.name | truncate : 7" style="margin: 0 0 0 1rem;"
                          *ngIf="this.campaign?.geoCull?.name"></h3>
                    </div>
                  </div>
                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : commercial?.geoCull}" icon="globe"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 [innerHTML]="this.commercial?.geoCull?.name | truncate : 7" style="margin: 0 0 0 1rem;"
                          *ngIf="this.commercial?.geoCull?.name"></h3>
                    </div>
                  </div>
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('GeoCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : requirement?.geoCull}" icon="globe"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="this.requirement?.geoCull?.name">{{ requirement?.geoCull?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.geoFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button (click)="changeWizardState('GeoCullSelect')"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate }}"
                                 placement="top" container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='GeoCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!this.requirement?.geoCull && permissionService.hasPermissions([permissionService.Permission.cull_geo_create])"
                        (click)="changeWizardState('GeoCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='GeoCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="this.requirement?.geoCull && !this.requirement?.geoCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_geo_edit])"
                        (click)="changeWizardState('GeoCullEdit')"
                        ngbTooltip="{{'lang.globals.editFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='GeoCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="this.requirement?.geoCull" (click)="sliceCull($event, 'GeoCull')"
                                 container="body"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate }}" placement="top"
                                 classes="btn-danger m-0">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

              </div>
              <div class="wizard__footerActions">
                <button type="button" [disabled]="wizardState!=='Map'"
                        ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}"
                        placement="top" container="body"
                        (click)="nextStep(wizard, tab1)"
                        class="btn btn-default btn-wizard">{{ 'lang.globals.previous' | translate }}
                </button>
                <button type="button" [disabled]="wizardState!=='Map' || createRequirementClick"
                        ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}"
                        placement="top" container="body"
                        (click)="createAndUpdateRequirement($event, wizard, tab3)"
                        class="btn btn-primary btn-wizard">{{ 'lang.globals.next' | translate }}
                </button>
              </div>
            </div>
          </sb-wizard-tab>
          <sb-wizard-tab #tab3 titleText="{{ 'lang.wizard.tabs.bookings' | translate }}" icon="bookings"
                         [disabled]="(!form.valid) || (!requirement)">
            <div class="wizard__forms px-5 pb-5">

              <sb-comp-requirement-booking-assignment
                *ngIf="wizard.selectedTab === tab3"
                (bookingsChanged)="updateBookings($event)"
                (loadingChanged)="setLoading($event)"
                (requirementDataChanged)="requirementDataChanged($event)"
                [requirementData]="requirement"
                [customer]="campaign.customer"
                [duration]="commercial?.duration">
              </sb-comp-requirement-booking-assignment>

              <div class="wizard__footerActions">
                <button type="button" (click)="nextStep(wizard, tab2); createRequirementClick = false;"
                        class="btn btn-default btn-wizard">{{ 'lang.globals.previous' | translate }}
                </button>
                <button type="button" (click)="finish()" [disabled]="!requirement?.bookings"
                        class="btn btn-success btn-wizard">{{ 'lang.globals.submit' | translate }}
                </button>
              </div>
            </div>
          </sb-wizard-tab>
          <div *ngIf="wizard.selectedTab !== tab3"
               class="wizard__aside wizard__aside--half wizard__aside--right p-0 flex-column wizardFilterBG">
            <div *ngIf="wizardState!=='Map'" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon icon="cancel" class="icon-in-btn mr-1"></sb-icon>
                {{ 'lang.globals.closeFilterSelection' | translate }}
              </button>
            </div>

            <filter-edit class="w-100 p-4" *ngIf="wizardState==='TimeCullEdit'" [isInSidebarContext]=true
                         [cullId]="requirement?.timeCull?.id" [type]="'TimeCull'"
                         (submitSuccess)="filterSubmitSuccess($event)"></filter-edit>

            <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                 *ngIf="wizardState==='TimeCullSelect'"
                                 preselectType="TimeCull" [preselectedCompany]="campaign?.customer"
                                 (selectedFilter)="selectFilter($event)"></sb-page-filter-list>

            <filter-edit class="w-100 p-4" *ngIf="wizardState==='PlayerCullEdit'" [isInSidebarContext]=true
                         [cullId]="requirement?.playerCull?.id" [type]="'PlayerCull'"
                         (submitSuccess)="filterSubmitSuccess($event)"></filter-edit>

            <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                 *ngIf="wizardState==='PlayerCullSelect'"
                                 preselectType="PlayerCull" [preselectedCompany]="campaign?.customer"
                                 (selectedFilter)="selectFilter($event)"></sb-page-filter-list>

            <filter-edit class="w-100 p-4" *ngIf="wizardState==='GeoCullEdit'" [isInSidebarContext]=true
                         [cullId]="requirement?.geoCull?.id" [type]="'GeoCull'"
                         (submitSuccess)="filterSubmitSuccess($event)"></filter-edit>

            <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                 *ngIf="wizardState==='GeoCullSelect'"
                                 preselectType="GeoCull" [preselectedCompany]="campaign?.customer"
                                 (selectedFilter)="selectFilter($event)"></sb-page-filter-list>

            <div *ngIf="wizardState==='Map'">
              <sb-targeting-preview [wizardPreviewState]="wizardPreviewState"
                                    (changeWizardState)="changeWizardPreviewState($event)"
                                    [requirementPreviewData]="previewRequirementData"
                                    [commercialPreviewData]="commercial"
                                    [campaignPreviewData]="campaign"></sb-targeting-preview>
              <sb-comp-cluster-map *ngIf="wizardPreviewState==='locationMap'" [clusters]="clusters"
                                   (minMaxPointsChange)="refreshMap($event)"
                                   style="width: 100%;display: block;"></sb-comp-cluster-map>
              <div *ngIf="wizardPreviewState==='locationList'" class="w-100 p-4" style="padding-top: 7rem!important;">
                <sb-page-inventory-wrapper [isInIntegratedContext]="true" [playerCull]="requirement?.playerCull"
                                           [geoCull]="requirement?.geoCull"></sb-page-inventory-wrapper>
              </div>
            </div>
          </div>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
